import { useEffect, useRef } from 'react';
import { useGame } from '../../game/store';
import { useSettings } from '../../stores/settings-store';
import { useGameInstance } from './GameContext';

export function MinimapPanel() {
  const game = useGameInstance();
  const ref = useRef<HTMLCanvasElement>(null);
  const zoneName = useGame((s) => s.zoneName);
  const connection = useGame((s) => s.connection);
  const ping = useGame((s) => s.ping);
  useEffect(() => {
    if (!game || !ref.current) return;
    game.minimapCanvas = ref.current;
    return () => {
      if (game.minimapCanvas === ref.current) game.minimapCanvas = null;
    };
  }, [game]);
  const dot = connection !== 'online' ? 'bad' : ping > 200 ? 'warn' : '';
  return (
    <div className="minimap-wrap">
      <canvas
        ref={ref}
        className="minimap"
        width={196}
        height={196}
        aria-label="Minimap (press M for the world map)"
        onClick={() => useGame.setState((s) => ({ windows: { ...s.windows, map: !s.windows.map } }))}
      />
      <div className="minimap-label">{zoneName}</div>
      <div className="net-badge" aria-live="polite">
        <span>
          <span className={`net-dot ${dot}`} />
          {connection === 'online' ? `${ping} ms` : connection}
        </span>
        <button
          className="btn btn-ghost btn-sm"
          style={{ padding: '0 4px' }}
          onClick={() => useSettings.getState().update({ showFps: !useSettings.getState().showFps })}
          title="Toggle performance stats"
        >
          ⓘ
        </button>
      </div>
    </div>
  );
}
